module.exports = __webpack_public_path__ + "img/customer1_8.327f6da0.png";